import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=41a3fa4c&scoped=true"
import script from "./DadosGerais.vue?vue&type=script&lang=js"
export * from "./DadosGerais.vue?vue&type=script&lang=js"
import style0 from "./DadosGerais.vue?vue&type=style&index=0&id=41a3fa4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a3fa4c",
  null
  
)

export default component.exports